import React, { Component } from 'react'
import { BsTruck, BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineSearch, AiOutlineReload } from "react-icons/ai";
import { getInformationWithDataV3 } from '../../../services/CABE';
import { getValueCookie } from '../../../services/cookieService';
import "../../../css/general-style.css"
import '../../../css/dashboard.css'
import { Menu } from "../../../components/Menu/Menu";
import LoadingWindow from '../../../components/LoadingWindow';
import ExcelDocument from '../../../components/ExcelDocument';
import { getDataSet } from '../../../functions/generateDataSetExcel';
import { getDateFromReports } from '../../../functions/dateFormat';
import { OrderArray } from '../../../functions/generalFunctions';

export default class CurrentShippedItemsReportV3 extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        loading: false,
        loaded: false,
        errorMessage: '',
        data: [],
        filterData: [],
        search: '',
        order: false,
        SalespersonNo: '',
        CustomerNo: '',
        Start: '',
        End: '',
    }

    Contains(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }
        return false
    }

    handleSearch = (e) => {
        const search = e.target.value
        const filterData = search === '' ? this.state.data : this.state.data.filter(d =>
            this.Contains(d.SalesOrderNo, search) ||
            this.Contains(d.ItemCode, search) ||
            this.Contains(d.Description, search) ||
            this.Contains(d.CustomerNo, search) ||
            this.Contains(d.BillToName, search) ||
            this.Contains(d.InvoiceNo, search)
        )
        this.setState({ search, filterData })
    }

    OrderInformation(key, asc) {
        const order = OrderArray(this.state.filterData, key, asc)
        this.setState({ filterData: order, order: !asc })
    }

    loadData = async () => {
        this.setState({ loading: true, errorMessage: '' })
        if (this.ModalLoading.current) this.ModalLoading.current.showState(true);

        const payload = {
            SalespersonNo: this.state.SalespersonNo,
            CustomerNo: this.state.CustomerNo,
            Start: this.state.Start,
            End: this.state.End,
        }

        try {
            const response = await getInformationWithDataV3('/v3/report/current-shipped-items', payload)
            if (!response || !response.status || response.status.code !== 1) {
                this.setState({ loading: false, loaded: true, data: [], filterData: [], errorMessage: 'No se pudo cargar el reporte.' })
                if (this.ModalLoading.current) this.ModalLoading.current.showState(false);
                return
            }
            const data = Array.isArray(response.data) ? response.data : []
            this.setState({ loading: false, loaded: true, data, filterData: data, search: '' })
        } catch (error) {
            this.setState({ loading: false, loaded: true, data: [], filterData: [], errorMessage: error.message || 'Error al cargar el reporte.' })
        } finally {
            if (this.ModalLoading.current) this.ModalLoading.current.showState(false);
        }
    }

    render() {
        const { filterData, loading, loaded, errorMessage } = this.state
        const hasData = filterData.length > 0
        const sortArrows = <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>

        const rowClass = (item) => {
            const shipped = Number(item.QuantityShipped)
            const ordered = Number(item.QuantityOrdered)
            if (shipped === 0) return 'status-danger'
            if (shipped < ordered) return 'status-warning'
            return 'status-success'
        }

        return (
            <div className="dash-page" style={{ paddingTop: '30px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '3rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsTruck style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Current Shipped Items Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasData ? `${filterData.length} line items loaded` : 'Query shipment status across current sales orders'}
                        </p>
                    </div>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>

                    {/* Filters */}
                    <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', padding: '1.25rem' }}>
                        <div className="row g-3 align-items-end">
                            <div className="col-sm-6 col-md-3">
                                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '0.25rem' }}>Salesperson No</label>
                                <input type="text" className="form-control form-control-sm" placeholder="All"
                                    value={this.state.SalespersonNo}
                                    onChange={(e) => this.setState({ SalespersonNo: e.target.value })}
                                    style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                            </div>
                            <div className="col-sm-6 col-md-3">
                                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '0.25rem' }}>Customer No</label>
                                <input type="text" className="form-control form-control-sm" placeholder="All"
                                    value={this.state.CustomerNo}
                                    onChange={(e) => this.setState({ CustomerNo: e.target.value })}
                                    style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                            </div>
                            <div className="col-sm-6 col-md-2">
                                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '0.25rem' }}>Order Date From</label>
                                <input type="date" className="form-control form-control-sm"
                                    value={this.state.Start}
                                    onChange={(e) => this.setState({ Start: e.target.value })}
                                    style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                            </div>
                            <div className="col-sm-6 col-md-2">
                                <label style={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748B', display: 'block', marginBottom: '0.25rem' }}>Order Date To</label>
                                <input type="date" className="form-control form-control-sm"
                                    value={this.state.End}
                                    onChange={(e) => this.setState({ End: e.target.value })}
                                    style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }} />
                            </div>
                            <div className="col-sm-6 col-md-2">
                                <button onClick={this.loadData} disabled={loading}
                                    className="btn"
                                    style={{ width: '100%', background: loading ? '#94A3B8' : '#2563EB', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.4rem 1rem', fontSize: '0.85rem', cursor: loading ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}>
                                    <AiOutlineReload /> {loading ? 'Loading...' : 'Search'}
                                </button>
                            </div>
                        </div>
                    </div>

                    {errorMessage && (
                        <div className="metric-card status-danger mb-4" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <span style={{ fontSize: '1.5rem', color: '#DC2626', fontWeight: 700 }}>✕</span>
                            <div>
                                <div style={{ fontWeight: 700, color: '#991B1B', fontSize: '0.95rem' }}>Error</div>
                                <div style={{ color: '#DC2626', fontSize: '0.8rem' }}>{errorMessage}</div>
                            </div>
                        </div>
                    )}

                    {!loaded && !loading && !errorMessage && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <BsTruck style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Set filters (optional) and click <strong>Search</strong> to load current sales order shipment status.</p>
                        </div>
                    )}

                    {loaded && !loading && filterData.length === 0 && !errorMessage && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>No results for the current filters.</p>
                        </div>
                    )}

                    {/* Table */}
                    {hasData && (
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.875rem 1.25rem', display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                                <div style={{ position: 'relative', flex: 1 }}>
                                    <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)' }} />
                                    <input
                                        value={this.state.search}
                                        onChange={this.handleSearch}
                                        placeholder="Search by Sales Order, Item Code, Description, Customer, Invoice..."
                                        type="text"
                                        style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                                    />
                                </div>
                                <ExcelDocument
                                    archname={'Current Shipped Items ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                    sheetname={'Current Shipped Items'}
                                    data={getDataSet(filterData,
                                        ['Sales Order', 'Order Date', 'Customer No', 'Bill To Name', 'Item Code', 'Description', 'Qty Ordered', 'Qty Shipped', 'Invoice No'],
                                        ['SalesOrderNo', 'OrderDate', 'CustomerNo', 'BillToName', 'ItemCode', 'Description', 'QuantityOrdered', 'QuantityShipped', 'InvoiceNo'])} />
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className='table table-clean mb-0'>
                                    <thead>
                                        <tr className="text-center">
                                            <th onClick={() => this.OrderInformation('SalesOrderNo', this.state.order)} style={{ cursor: 'pointer' }}>Sales Order {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation('OrderDate', this.state.order)} style={{ cursor: 'pointer' }}>Order Date {sortArrows}</th>
                                            <th className="text-start">Customer</th>
                                            <th>Item Code</th>
                                            <th className="text-start">Description</th>
                                            <th onClick={() => this.OrderInformation('QuantityOrdered', this.state.order)} style={{ cursor: 'pointer' }}>Qty Ordered {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation('QuantityShipped', this.state.order)} style={{ cursor: 'pointer' }}>Qty Shipped {sortArrows}</th>
                                            <th>Invoice No</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filterData.map((element, e) => (
                                            <tr key={e} className={rowClass(element)}>
                                                <td className="text-center" style={{ fontWeight: 700, color: '#334155' }}>{element.SalesOrderNo}</td>
                                                <td className="text-center" style={{ fontSize: '0.8rem', color: '#64748B' }}>{element.OrderDate || '—'}</td>
                                                <td className="text-start" style={{ fontSize: '0.85rem' }}>
                                                    <div style={{ fontWeight: 600, color: '#334155' }}>{element.CustomerNo}</div>
                                                    <div style={{ color: '#94A3B8', fontSize: '0.75rem' }}>{element.BillToName}</div>
                                                </td>
                                                <td className="text-center">
                                                    <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{element.ItemCode}</span>
                                                </td>
                                                <td className="text-start" style={{ fontSize: '0.875rem' }}>{element.Description}</td>
                                                <td className="text-center">{element.QuantityOrdered}</td>
                                                <td className="text-center" style={{ fontWeight: 700, color: Number(element.QuantityShipped) === 0 ? '#DC2626' : Number(element.QuantityShipped) < Number(element.QuantityOrdered) ? '#D97706' : '#059669' }}>
                                                    {element.QuantityShipped}
                                                </td>
                                                <td className="text-center" style={{ fontSize: '0.8rem', color: '#64748B' }}>{element.InvoiceNo || '—'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td colSpan={8} style={{ color: '#94A3B8', fontSize: '0.78rem' }}>
                                                {filterData.length} line items · <span style={{ color: '#059669' }}>green</span> = fully shipped, <span style={{ color: '#D97706' }}>amber</span> = partial, <span style={{ color: '#DC2626' }}>red</span> = not shipped
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
